/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { ReferralLevel, ReferralLevelFromJSON, ReferralLevelFromJSONTyped, ReferralLevelToJSON } from './ReferralLevel'

/**
 *
 * @export
 * @interface AffiliatePackageInfo
 */
export interface AffiliatePackageInfo {
  /**
   *
   * @type {ReferralLevel}
   * @memberof AffiliatePackageInfo
   */
  name: ReferralLevel
  /**
   *
   * @type {number}
   * @memberof AffiliatePackageInfo
   */
  threshold: number
  /**
   *
   * @type {number}
   * @memberof AffiliatePackageInfo
   */
  referralFarming: number
  /**
   *
   * @type {number}
   * @memberof AffiliatePackageInfo
   */
  teamFarming: number
  /**
   *
   * @type {number}
   * @memberof AffiliatePackageInfo
   */
  referralTrading: number
  /**
   *
   * @type {number}
   * @memberof AffiliatePackageInfo
   */
  teamTrading: number
  /**
   *
   * @type {number}
   * @memberof AffiliatePackageInfo
   */
  cashback: number
}

export function AffiliatePackageInfoFromJSON(json: any): AffiliatePackageInfo {
  return AffiliatePackageInfoFromJSONTyped(json, false)
}

export function AffiliatePackageInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliatePackageInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: ReferralLevelFromJSON(json['name']),
    threshold: json['threshold'],
    referralFarming: json['referralFarming'],
    teamFarming: json['teamFarming'],
    referralTrading: json['referralTrading'],
    teamTrading: json['teamTrading'],
    cashback: json['cashback'],
  }
}

export function AffiliatePackageInfoToJSON(value?: AffiliatePackageInfo | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: ReferralLevelToJSON(value.name),
    threshold: value.threshold,
    referralFarming: value.referralFarming,
    teamFarming: value.teamFarming,
    referralTrading: value.referralTrading,
    teamTrading: value.teamTrading,
    cashback: value.cashback,
  }
}
